"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.classes = void 0;
var classes = {
  otpFieldContainer: 'sm-secrets-otp-field-container',
  otpFieldHeadingContainer: 'sm-secrets-otp-heading-container',
  otpFieldName: 'sm-secrets-otp-field-name',
  otpFieldTimer: 'sm-secrets-otp-timer-clock',
  otpFieldCopyBtn: 'sm-secrets-otp-copy-button',
  otpValueText: 'sm-secrets-otp-value-text',
  otpLoadingError: 'sm-secrets-otp-loading-error',
  copyBtnCss: 'sm-secrets-otp-copy-btn-css'
};
exports.classes = classes;